import { getText } from '@storebrand-digital/fms-translations';

import type { MortgageParticipantProperties } from '../../app/consts/types/apiTypes';

export function extractDebtCategories(
  debtOverview?: MortgageParticipantProperties['debtOverview'],
): { amount: number; label: string }[] {
  return [
    {
      amount: debtOverview?.mortgages?.sum,
      label: getText('debtOverviewView.existingHouseLoan.label'),
    },
    {
      amount: debtOverview?.carLoans?.sum,
      label: getText('debtOverviewView.carLoan.label'),
    },
    {
      amount: debtOverview?.studentLoans?.sum,
      label: getText('debtOverviewView.studentLoan.label'),
    },
    {
      amount: debtOverview?.unsecuredDebts?.sum,
      label: getText('debtOverviewView.unsecuredDebt.label'),
    },
    {
      amount: debtOverview?.otherDebts?.sum,
      label: getText('debtOverviewView.otherDebt.label'),
    },
  ].filter(
    (debt): debt is { amount: number; label: string } =>
      typeof debt.amount === 'number' && debt.amount > 0,
  );
}

export function calculateTotalDebt(
  debtOverview?: MortgageParticipantProperties['debtOverview'],
): number {
  return (
    (debtOverview?.mortgages?.sum ?? 0) +
    (debtOverview?.carLoans?.sum ?? 0) +
    (debtOverview?.studentLoans?.sum ?? 0) +
    (debtOverview?.otherDebts?.sum ?? 0) +
    (debtOverview?.unsecuredDebts?.sum ?? 0)
  );
}
